export const installGoogleTranslateShim = () => {
  try {
    let value
    let armed = true

    const defer =
      typeof queueMicrotask === "function"
        ? queueMicrotask
        : (cb) => Promise.resolve().then(cb)

    Object.defineProperty(window, "default_tr", {
      configurable: true,
      get() {
        return armed ? undefined : value
      },
      set(v) {
        value = v
        armed = false
        defer(() => {
          armed = true
          value = undefined
        })
      },
    })

    return true
  } catch (e) {
    return false
  }
}

export default installGoogleTranslateShim
